import React from 'react'
import 'src/components/house/shineOverlay.css'

const ShineOverlay = () => {
  return <span aria-hidden="true" className="shine-overlay" />
}

export default ShineOverlay
